import React from "react";
import { SvgIcon } from "@mui/material";

const MessangerIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 49.26 54.572">
      <path
        id="Path_2241"
        data-name="Path 2241"
        d="M73.527,39.649A15.542,15.542,0,0,0,61.246,64.714L55.8,70.732H73.527a15.541,15.541,0,1,0,0-31.083Zm1.8-8.365h3.424v3.424H75.329ZM84.421,16.16A16.836,16.836,0,0,1,98.363,42.434l6.7,7.4H88.809a16.145,16.145,0,0,0-1.175-2.591h11.6L95.017,42.58c2.344-3.018,3.65-5.689,3.65-9.583a14.246,14.246,0,1,0-27.111,6.124,16.128,16.128,0,0,0-2.6.537,16.844,16.844,0,0,1,15.467-23.5ZM82.708,31.285h3.424v3.424H82.708Zm7.38,0h3.424v3.424H90.088ZM64.436,53.479H67.86V56.9H64.436Zm7.378,0h3.424V56.9H71.815Zm7.38,0h3.424V56.9H79.194Z"
        transform="translate(-55.8 -16.16)"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};

export default MessangerIcon;
